import { Check } from "@vibe/icons";
import { useSyncWizardStep4ViewModel } from "./SyncWizardContext";

export function SyncWizardStep4() {
  const {
    currentBoardName,
    selectedItems,
    targetBoard,
    targetGroup,
    confirmed,
    submitErrorMessage,
  } = useSyncWizardStep4ViewModel();

  const itemCount = selectedItems.length;

  if (confirmed) {
    return (
      <div className="flex flex-col gap-6 justify-center items-center py-8">
        <div className="relative">
          <div className="w-20 h-20 rounded-full bg-[#00c875] flex items-center justify-center shadow-lg">
            <Check size={38} color="white" />
          </div>
          <div className="absolute -top-1 -right-1 text-xl">🎉</div>
        </div>

        <div className="text-center">
          <p className="text-[20px] font-semibold text-[#323338]">It's live!</p>
        </div>

        <div className="w-full bg-[#f6f7fb] rounded-xl border border-[#e6e9ef] px-5 py-4">
          <p className="text-[14px] text-[#323338] leading-relaxed">
            <span className="font-semibold">
              {itemCount} {itemCount === 1 ? "item" : "items"}
            </span>{" "}
            from <span className="font-semibold">{currentBoardName}</span>{" "}
            {itemCount === 1 ? "is" : "are"} now being shared with the{" "}
            <span className="font-semibold" style={{ color: targetBoard?.color }}>
              {targetBoard?.name}
            </span>{" "}
            board,{" "}
            <span className="font-semibold" style={{ color: targetGroup?.color }}>
              {targetGroup?.name}
            </span>{" "}
            group.{" "}
          </p>
        </div>

        <p className="text-[12px] text-[#676879]">
          Click Done to go to{" "}
          <span className="font-semibold" style={{ color: targetBoard?.color }}>
            {targetBoard?.name}
          </span>{" "}
          and see your shared items there.
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-5">
      <p className="text-[12px] text-[#676879]">Review before confirming.</p>

      {submitErrorMessage && (
        <div className="rounded-lg border border-solid border-[#f3d8d8] bg-[#fff5f5] px-4 py-3">
          <p className="text-[12px] text-[#c23d3d] !mb-0">{submitErrorMessage}</p>
        </div>
      )}

      <div className="bg-[#f6f7fb] rounded-xl border border-[#e6e9ef] px-5 py-5">
        <p className="text-[15px] text-[#323338] leading-relaxed">
          {" "}
          <span className="font-semibold">
            {itemCount} {itemCount === 1 ? "item" : "items"}{" "}
          </span>
          from <span className="text-[#323338] font-semibold">{currentBoardName}</span> will be
          shared with the{" "}
          <span className="font-semibold" style={{ color: targetBoard?.color }}>
            {targetBoard?.name}
          </span>{" "}
          board,{" "}
          <span className="font-semibold" style={{ color: targetGroup?.color }}>
            {targetGroup?.name}
          </span>{" "}
          group.
        </p>
      </div>
    </div>
  );
}
